<script>
import commomUtils from '@/mixins/common-utils.js'
import { widgetActions } from '@state/helpers'

export default {
  mixins: [commomUtils()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tags: [],
      selectedtem: '',
    }
  },
  watch: {
    selectedtem() {
      this.commitWidgetChanges({
        widgetName: 'ResolveOptions',
        data: {
          selectedtem: this.selectedtem,
        },
      })
    },
  },
  created() {
    this.selectedtem = this.componentData.values[0].id
  },
  methods: {
    ...widgetActions,
    getselectedtem: function() {
      return this.selectedtem
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <h4>¿Cómo te gustaría que resolvamos tu problema?</h4>

    <div>
      <BaseRadio
        v-for="v in componentData.values"
        :class="$style.container__radios"
        :key="v.id"
        :value="v.id"
        v-model="selectedtem"
        :label="v.value"
      />
    </div>

  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1rem;
  margin-top: 1rem;
  text-align: left !important;

  h4 {
    @extend %typography-medium;

    margin: 0 0 1rem 0;
    font-weight: bold;
    color: $darker-gray;
  }

  &__radios {
    margin-bottom: 0.7rem;
    font-size: 1.2rem;
    color: $darker-gray;
    // [type='radio']:checked + label:after {
    //   background-color: #42c798;
    // }

    // [type='radio']:checked + label:after,
    // [type='radio']:checked + label:before,
    // [type='radio']:checked + label:after {
    //   border: 2px solid #42c798;
    // }
  }
}
</style>
